import { StorageKey } from 'modules/storage/const'
import { ClientStorage } from 'modules/storage/storage'

const urlStateStorage = new ClientStorage<Record<string, string>>(
  StorageKey.UrlStateMap,
  'localStorage',
)
let memoryCache: Record<string, string> | null = null

const getMap = (): Record<string, string> => {
  if (!memoryCache) {
    memoryCache = urlStateStorage.getValue({})
  }

  return memoryCache
}

const persistMap = () => {
  if (memoryCache) {
    urlStateStorage.setValue(memoryCache)
  }
}

export const UrlStateStorage = {
  save: (uniqueKey: string, encodedStr: string) => {
    const map = getMap()

    if (map[uniqueKey] !== encodedStr) {
      map[uniqueKey] = encodedStr

      persistMap()
    }
  },
  load: (uniqueKey: string): string | null => {
    const map = getMap()

    return map[uniqueKey] || null
  },

  refresh: () => {
    memoryCache = null
  },
}
